jQuery(function($)
{
    initSmoothScroll();
    initAboveHeaderHandler();
    initSearchHandler();
    initBanner();
    initSearchFix();

    function initSearchFix() {
      $('.search-results .fl-post-content p').each(function (i, elem) {
        var subString = 'This h1 is for SEO and is only visible when editing this page.';
        var i         = $(elem).text().indexOf(subString);
        var text;

        if (i > -1) {
          i = i + subString.length;

          text = $(elem).text().substring(i);

          $(elem).text(text);
        }
      });
    }

    function initSmoothScroll() {

        var target = window.location.hash,
            target = target.replace('#', '');

        window.location.hash = "";

        $(window).load(function() {
            if (target) {
                $('html, body').animate({
                    scrollTop: $("#" + target).offset().top - 50
                }, 700, 'swing', function () {});
            }
        });
    }

    function initAboveHeaderHandler() {
      try {
        var $sections = $('.above-header-row');

        $sections.each(function (i, elem) {
          var $elem = $(elem);

          $elem.find('.icon-close').click(function () {
            closeSections();

            if ($elem.hasClass('above-header-row-banner')) {
              sessionStorage.setItem('banner-close', true);
            }
          });
        });

        function closeSections() {
          $sections.hide();
          $sections.removeClass('active-section');
        }
      } catch(e) {
        console.log(e);
      }
    }

    function initSearchHandler() {
      try {
        $('#menu-top-nav').append('<li class="search-trigger-wrap top-nav_action-link menu-item menu-item-type-post_type menu-item-object-page"><div class="fl-module fl-module-icon search-trigger"><div class="fl-module-content fl-node-content"><div class="fl-icon-wrap"> <span class="fl-icon"> <i class="fa fa-search"></i> </span></div></div></div>');

        var $trigger = $('#menu-top-nav .search-trigger');
        var $search  = $('.above-header-row-search');

        $trigger.click(function (event) {
          if ($search.hasClass('active-section')) {
            $search.slideUp('slow');
          }
          else {
            $('.above-header-row').hide();
            $search.slideDown('400');
          }

          $search.toggleClass("active-section");
        });

        $search.find('.search-icon-glass').click(function () {
          $search.find('form').submit();
        });
      }catch(e){
        console.log(e);
      }
    }

    //Test Commentt
    function initBanner() {
      try {
        var $bannerRow   = $('.above-header-row-banner');
        var $bannerCheck = $('.gbf_banner_content_wrap'); // If this class isn't present we aren't rendering the announcement banner

        setTimeout(function () {
          if (!($bannerCheck && $bannerCheck[0])) {
            return;
          }

          if (sessionStorage.getItem('banner-close')) {
            return;
          }

          $bannerRow.slideDown('400');
        }, 400);
      }catch(e){
        console.log(e);
      }
    }
});
